/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetToolsetSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetToolsetSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetToolsetSecurity = {
  option1?: GetToolsetSecurityOption1 | undefined;
  option2?: GetToolsetSecurityOption2 | undefined;
};

export type GetToolsetRequest = {
  /**
   * The slug of the toolset
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetToolsetSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetToolsetSecurityOption1$outboundSchema: z.ZodMiniType<
  GetToolsetSecurityOption1$Outbound,
  GetToolsetSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getToolsetSecurityOption1ToJSON(
  getToolsetSecurityOption1: GetToolsetSecurityOption1,
): string {
  return JSON.stringify(
    GetToolsetSecurityOption1$outboundSchema.parse(getToolsetSecurityOption1),
  );
}

/** @internal */
export type GetToolsetSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetToolsetSecurityOption2$outboundSchema: z.ZodMiniType<
  GetToolsetSecurityOption2$Outbound,
  GetToolsetSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getToolsetSecurityOption2ToJSON(
  getToolsetSecurityOption2: GetToolsetSecurityOption2,
): string {
  return JSON.stringify(
    GetToolsetSecurityOption2$outboundSchema.parse(getToolsetSecurityOption2),
  );
}

/** @internal */
export type GetToolsetSecurity$Outbound = {
  Option1?: GetToolsetSecurityOption1$Outbound | undefined;
  Option2?: GetToolsetSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetToolsetSecurity$outboundSchema: z.ZodMiniType<
  GetToolsetSecurity$Outbound,
  GetToolsetSecurity
> = z.pipe(
  z.object({
    option1: z.optional(z.lazy(() => GetToolsetSecurityOption1$outboundSchema)),
    option2: z.optional(z.lazy(() => GetToolsetSecurityOption2$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getToolsetSecurityToJSON(
  getToolsetSecurity: GetToolsetSecurity,
): string {
  return JSON.stringify(
    GetToolsetSecurity$outboundSchema.parse(getToolsetSecurity),
  );
}

/** @internal */
export type GetToolsetRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetToolsetRequest$outboundSchema: z.ZodMiniType<
  GetToolsetRequest$Outbound,
  GetToolsetRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getToolsetRequestToJSON(
  getToolsetRequest: GetToolsetRequest,
): string {
  return JSON.stringify(
    GetToolsetRequest$outboundSchema.parse(getToolsetRequest),
  );
}
